import CardWithTables from './container';

export default CardWithTables;



// WEBPACK FOOTER //
// ./src/routes/Embed/CallForImpact/CardWithTables/index.js